export const GA_IDS = {
  TRACKING_GA4_ID: "G-LV5XHKK6GH",
};
